export default __webpack_public_path__ + "static/media/pursuit-menu-echelon-on.97ba0ad2.svg";